import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const evidenceCompleteIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 64"><path d="M53 16H37.1V0L53 16zM31.8 0v21.333H53V64H0V0h31.8zm6.834 29.333L22.456 45.85 14.3 38.048 10.6 41.862l11.925 11.471L42.4 33.076l-3.766-3.743z"/></svg>`
);
